import { createReducer, on } from '@ngrx/store';
import * as fromSharedActions from '../actions/shared.action';

export const featureKey = 'shared';

export interface State {
  showLoading: boolean;
  capturedImage: any;
  showBackFront: any;
}

export const initialState: State = {
  showLoading: false,
  capturedImage: null,
  showBackFront: null,
};

export const reducer = createReducer(
  initialState,
  on(fromSharedActions.setLoadingSpinner, (state: State, props: any) => ({
    ...state,
    showLoading: props.status,
  })),
  on(fromSharedActions.getCapturedImage, (state: State, props: any) => ({
    ...state,
    capturedImage: { data: props.data, captureType: props.captureType },
  })),
  on(fromSharedActions.resetCapturedImage, (state: State, props: any) => ({
    ...state,
    capturedImage: {  ...initialState.capturedImage },
  })),
  on(fromSharedActions.showBackFront, (state: State, props: any) => ({
    ...state,
    showBackFront: props.data,
  })),
);
